import { MetaDefinition } from '@angular/platform-browser';

export const Metas: MetaDefinition[] = [
  {
    name: 'robots',
    content: 'index,follow',
  },
  {
    property: 'og:type',
    content: 'profile',
  },
  {
    property: 'og:site_name',
    content: 'atsii.fr',
  },
];
